import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { THUMB_UP_MESSAGE } from '../../../slices/thunks';
import { open_success_modal } from '../../../slices/Success_Modal/reducer';

const Thumb_Down_Reason_Modal = ({ Bot_Seq_Id, Group_Id, Thread_Id }) => {
    const [modal_standard, setmodal_standard] = useState(false);
    const dispatch = useDispatch();
    const [reason, setreason] = useState('');
    const [error, setError] = useState('');


    function tog_standard() {
        setmodal_standard(!modal_standard);
        setError('');
        setreason('');
    }

    const onSubmit = () => {
        if (!reason.trim()) {
            setError('Please enter a reason before submitting.');
            return;
        }

        dispatch(THUMB_UP_MESSAGE({
            Bot_Seq_Id,
            Group_Id,
            Thread_Id,
            User_Feedback: "DOWN",
            Thumbdown_Reason: reason.trim()
        }));


        dispatch(open_success_modal('Feedback Submitted !! '))

        setmodal_standard(false);
    
        setError('');
    };

    return (
        <>
            <Button
                className="rounded-pill"
                color="primary"
                id="dislike"
                onClick={tog_standard}
            >
                <i className="ri-thumb-down-line"></i>
            </Button>

            <Modal
                id="myModal"
                size="xl"
                isOpen={modal_standard}
                toggle={tog_standard}
            >
                <ModalHeader
                    className="modal-title"
                    id="myModalLabel"
                    toggle={tog_standard}
                >
                    What didn't work well?
                </ModalHeader>
                <ModalBody>
                    <div>
                        <textarea
                            value={reason}
                            onChange={(e) => {
                                setreason(e.target.value);
                                if (e.target.value.trim()) {
                                    setError('');
                                }
                            }}
                            className="form-control"
                            rows="3"
                        />
                        {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="light"
                        style={{ marginRight: '15px' }}
                        onClick={tog_standard}
                    >
                        Cancel
                    </Button>
                    <Button
                        color="primary"
                        onClick={onSubmit}
                    >
                        Submit
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default Thumb_Down_Reason_Modal;
